import React, { useRef } from 'react';
import { Link } from 'react-router-dom'; // For navigation
import imag from '../StyledComponents/img/logo (11).png'; // Import logo image

function CodePage() {
  // Create refs for each OTP input (6 inputs in this case)
  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null)
  ];

  // Focus the next input field after entering a value
  const handleInputChange = (e, index) => {
    if (e.target.value.length === 1 && index < inputRefs.length - 1) {
      // Move to the next input field when a character is entered
      inputRefs[index + 1].current.focus();
    }
  };

  return (
    <div className="code-main">
      <div className="log-in-inner">
        <div className="top">
          <div className="top-inner">
            <div className="logo">
              <img src={imag} alt="Logo" className="logo-w"/>
            </div>
          </div>
        </div>

        <div className="form">
          <form action="">
            <div className="logos">
              {/* <img src={imag} alt="Logo" className="logo-w" /> */}
            </div>
            <h2>Forgot Password</h2>
            <p>Enter your registered email to reset your password</p>
            <div className="form-group fullname">
              <label htmlFor="email">Email</label>
              <div className="password-container">

              <input type="email" id="email" placeholder="" />
              </div>

              <p>We've sent a code to your email. Please enter it below.</p>
            </div>

            <div className="form-group fullname">
              <label htmlFor="verificationCode">Verification Code</label>
              <div className="code">
                {/* OTP input fields */}
                {inputRefs.map((ref, index) => (
                  <input
                    key={index}
                    type="text"
                    ref={ref}
                    maxLength="1"
                    placeholder="0"
                    onChange={(e) => handleInputChange(e, index)}
                    autoFocus={index === 0} // Focus the first input initially
                  />
                ))}
              </div>
              <p className="resend">Resend Code</p>
            </div>

            <div className="btn">
              <Link to="/whooska/admin/reports/Change/Password">Verify Code</Link>
            </div>
          </form>
        </div>

        <div className="bottom">
          <div className="bottom-inner">
            <div className="text-content">
              <div className="copy">copyright @ WhooshkaTips</div>
              <div className="text">
                This page is for 18+ only. Gamble Responsibly. Visit
                <span> www.gamblinghelponline.org.vic.au</span> or call <br />
                Gambling Help on
                <span>1800 858 858</span>
                The chances are you are about to lose
              </div>
              <div className="policy">
                Privacy Policy | Terms & Conditions
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CodePage;
